var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{on:{"click":_vm.toHome}},[_c('LogoSvg',{attrs:{"alt":"logo"}}),(_vm.showTitle)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }